<template>
  <td :class="[tdClass, {'state-disabled': disabled}]" :colspan="colspan" :rowspan="rowspan">
    <component v-if="!hasSlot" :is="componentName" :model="model" v-bind="fieldProps" :readonly="disabled" :disabled="disabled" :title="title" />

    <slot v-else />

    <slot name="afterField" />
  </td>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
export default {
  name: 'w-table-cell',
  mixins: [modelMixin],
  props: {
    model: {
      type: Object,
      required: false
    },
    css: {
      type: String,
      default: '',
      required: false
    },
    colspan: [Number, String],
    rowspan: [Number, String],
    field: {
      type: String,
      required: false
    },
    colspan: [Number, String],
    rowspan: [Number, String],
    fieldProps: {
      type: Object,
      required: false,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    title: {
      type: String,
      default: '',
      required: false
      /* this.model.$schema.title w tabelkach jest zbędny, gdyby jednak był potrzebny: `:title="$schema.pole.$schema.title"`*/
    }
  },
  beforeMount() {
    if (this.isSimpleTd) {
      return;
    }

    const type = this.model.$schema.type;

    if (!this.fieldProps || this.fieldProps.appendicon === undefined) {
      switch (type) {
        case 'money':
          this.fieldProps.appendicon = 'zł';
      }
    }

    if (!this.fieldProps.placeholder) {
      switch (type) {
        case 'money':
          this.fieldProps.placeholder = '0,00';
        case 'number':
        case 'integer':
          this.fieldProps.placeholder = '0';
      }
    }
  },
  computed: {
    isSimpleTd() {
      return !this.model || this.hasSlot;
    },
    hasSlot() {
      return this.$slots && this.$slots.default;
    },
    componentName() {
      return this.field || this.innerComponent;
    },
    innerComponent() {
      if (this.isSimpleTd) {
        return;
      }

      const type = this.model.$schema.type;
      if (this.disabled || this.model.$schema.readOnly) return 'w-preview';
      if (this.model.$schema.format == 'date') return 'w-datepicker';
      switch (type) {
        case 'string':
        case 'money':
        case 'number':
          return 'w-input';
        case 'integer':
          return 'w-radio';
        case 'boolean':
          return 'w-checkbox';
        default:
          return 'w-input';
      }
    },
    tdClass: {
      get() {
        const arr = [this.css];

        if (this.model && this.model.$error) {
          arr.push('state-error');
        } else {
          arr.push('state-success');
        }

        if (this.isSimpleTd) {
          if (this.isDisabled) {
            arr.push('state-disabled');
          }
          return arr;
        }

        if (this.model.$schema.type === 'money' || this.model.$schema.type === 'number' || this.model.$schema.type === 'integer') {
          arr.push('text-right');
        }

        if (this.componentName === 'w-preview' || this.isDisabled) {
          arr.push('state-disabled');
        } else {
          switch (this.componentName) {
            case 'w-textarea':
              arr.push('textarea');
              break;
            case 'w-select':
            case 'w-vue-select':
              arr.push('select');
              break;
            case 'w-input':
            default:
              arr.push('input');
              break;
          }
        }
        return arr;
      }
    }
  }
};
</script>
